<script setup lang="ts">
import Spinner from "@/components/Spinner.vue";
</script>

<template>
  <div class="flex flex-1 h-full w-full items-center justify-center">
    <Spinner class="h-12 w-12" />
  </div>
</template>
